import * as React from "react";
import { ColumnHelper } from "@tanstack/react-table";
import _ from "lodash";

import { Text } from "src/library/components/Text";
import { ITerminology } from "src/library/utils";
import { IList } from "src/core/lists/api/lists.api";
import { getScheduleNaturalLanguage } from "src/core/schedules/utils";
import { NoWrapCell } from "src/core/shared/components/TableGlobalColumns";

/**
 * This function returns a reusable formated column definition for schedule data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param terminology
 * @returns column definition for schedule data
 */
export const scheduleColumn = (
  columnHelper: ColumnHelper<IList>,
  terminology: ITerminology
) => {
  return columnHelper.accessor("schedule", {
    id: "schedule",
    header: _.capitalize(terminology.schedule.singular.text),
    cell: info => {
      const list = info.row.original as IList;

      if (list?.schedule) {
        const { frequencyDays, startAndEndDates } = getScheduleNaturalLanguage(list.schedule, list.hasDetachedOrders || false, terminology);

        return (
          <NoWrapCell>
            <Text>
              {frequencyDays}
            </Text>

            <div style={{ paddingBottom: "20px" }} />

            <Text>
              {startAndEndDates}
            </Text>
          </NoWrapCell>
        );
      } else {
        return (
          <Text weight="light">
            No
            {" "}

            {terminology.schedule.singular.text}
          </Text>
        );
      }
    },
    enableSorting: false,
    enableColumnFilter: false,
    minSize: 150,
    meta: { style: { align: "left" } }
  });
};
